import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@store/store';
import { ShipmentStopsParams } from '@api/order-reporting/types/ShipmentStopsParams';



export const selectGridData = (state: RootState) => state.reportingShipmentStops.gridData;
export const selectDate = (state: RootState) => state.reportingShipmentStops.date;
export const selectCustomerId = (state: RootState) => state.reportingShipmentStops.customerId;
export const selectTileId = (state: RootState) => state.reportingShipmentStops.tileId;



export const selectParamCustomerId = createSelector(selectCustomerId, customerId => {
	if (!customerId || customerId.length === 0) return null;
	if (customerId.length < 7) return null;
	return customerId;
});



export const selectValidParams = createSelector(
	[
		selectDate,
		selectParamCustomerId,
		selectTileId,
	],(
		date: string | null,
		customerId: string | null,
		tileId: string | null,
	) => {
		if (!date) return null;
		let validParams: ShipmentStopsParams = {
			day: date,
			...(customerId && { customerId: customerId }),
			...(tileId && { tileId: tileId }),
		};
		return validParams;
	}
);